
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface NavLinkProps {
  sectionId?: string;
  href?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const NavLink: React.FC<NavLinkProps> = ({ 
  sectionId, 
  href, 
  children, 
  className = "text-itmgmt-dark-gray hover:text-itmgmt-medium-blue font-medium transition-colors block py-2 px-3",
  onClick 
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    
    if (sectionId) {
      // If not on homepage, navigate to homepage first
      if (location.pathname !== '/') {
        navigate('/');
        // Need to use setTimeout to ensure navigation completes before scrolling
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        // Already on homepage, just scroll
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };
  
  if (sectionId) {
    return (
      <button onClick={handleClick} className={className}>
        {children}
      </button>
    );
  }
  
  if (href) {
    return (
      <a href={href} className={className} onClick={onClick}>
        {children}
      </a>
    );
  }
  
  return <span className={className}>{children}</span>;
};

export default NavLink;
